import { RespuestaPrimerNivel } from './respuesta-primer-nivel'
import { JsonConverter } from '../JsonConverter'

export class PreguntaPrimerNivel implements JsonConverter {
  
  private _id: string
  private _texto: string
  private _indice: number
  private _respuestas: RespuestaPrimerNivel[]
  private _tipo: string

  constructor (
    id: string,
    texto: string,
    indice: number,
    respuestas: RespuestaPrimerNivel[],
    tipo: string
  ) {
    this._id = id
    this._texto = texto
    this._indice = indice
    this._respuestas = respuestas
    this._tipo = tipo
  }

  get id(): string {
    return this._id
  }

  get indice(): number {
    return this._indice
  }

  get texto(): string {
    return this._texto
  }

  get tipo(): string {
    return this._tipo
  }

  get respuestas(): RespuestaPrimerNivel[] {
    return this._respuestas
  }

  set respuestas(respuestas: RespuestaPrimerNivel[]) {
    this._respuestas = respuestas
  }

  toJson() {
    return {
      id: this.id,
      texto: this.texto,
      indice: this.indice,
      tipo: this.tipo,
      respuestas: this.respuestas.map( r => r.toJson() )
    }
  }

  toJsonD() {
    return {
      id: this.id,
      respuestas: this.respuestas.map( r => this.respuestaToJson(r) )
    }
  }

  respuestaToJson(r) {
    return {
      id: r.id,
      textoAbierto: r.textoAbierto
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/dominio/pregunta-primer-nivel.ts